import React, { useState } from "react";
import { useForm } from "react-hook-form";
import logo from "../img/exam_logo.png";
// import logo from "../img/logo.png";
import "../css/home.css";
import axios from "axios";
import { Spin } from "antd";
import { notification } from "antd";
import "react-toastify/dist/ReactToastify.css";
import Login from "./Login";

const citizenPrefixes = ["AA", "AZE", "AB", "AC"];
const foreignPrefixes = ["MYİ", "DYİ"];

const PREFIX = {
  "AA": 1,
  "AZE": 2,
  "AB": 3,
  "AC": "AC",
  "MYİ": "MYİ",
  "DYİ": "DYİ"
}

const EXAM_TYPES = [
  {
    id: 2,
    name: "Buraxılış imtahanı"
  },
  {
    id: 1,
    name: "Qəbul imtahanı"
  },
]

function Home() {
  const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm();
  const [login, setLogin] = useState(true)
  const [info, setInfo] = useState({});
  const [showInfo, setShowInfo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isForeignPerson, setIsForeignPerson] = useState(false);
  const [result, setResult] = useState("");
  const [examResults, setExamResults] = useState([]);

  // const examURL = "https://backimes.culture.az/api/exam-infos";
  // const resultUrl = "https://backimes.culture.az/api/teacher-exam-results";
  const resultUrl = "https://backimes.culture.az/api/v2/exam-results";
  const examUrl = "https://backimes.culture.az/api/student-exam/exam-results"

  const totalScore = examResults?.reduce((acc, curr) => acc + (curr.score ? Number(curr.score) : 0), 0);

  const subject_ids = [...new Set(examResults.map((examResult) => examResult?.subject_id))];
  const scoresBySubject = {};
  subject_ids.map((subjectId) => {
    const subjectScores = examResults.filter((examResult) => examResult?.subject_id === subjectId);
    const totalSubjectScore = subjectScores.reduce((acc, curr) => acc + (curr.score ? Number(curr.score) : 0), 0);
    scoresBySubject[subjectId] = Math.round(totalSubjectScore / subjectScores.length);
  });

  const subjects = [...new Map(examResults.map(u => [u.subject_id, {
    subject_id: u.subject_id,
    subject_name: u?.subject?.name,
    average_score: scoresBySubject[u.subject_id]
  }])).values()];

  const averageScoreTotal = subjects.reduce((acc, item) => item.average_score + acc, 0)
  const averageScore = Math.round(averageScoreTotal/subjects.length)

  const handleCheckboxChange = () => {
    setIsForeignPerson(prev => !prev);
    if (!isForeignPerson) {
      setValue("seriyaNo", foreignPrefixes[0]);
    } else {
      setValue("seriyaNo", citizenPrefixes[0]);
    }
  };
  const examType = watch("exam_type");

  const onSubmit = (data) => {
    const seriyaCombined = data.seriyaNo.toUpperCase() + data.seriyaValue;
    let params = {
      pin: data.fin,
      serial: seriyaCombined,
    };
    if (examType === "2") {
      params = {
        ...params,
        serial: isForeignPerson ? seriyaCombined : data.seriyaValue,
        prefix: PREFIX[data.seriyaNo.toUpperCase()],
        is_foreign_citizen: isForeignPerson ? 1 : 0
      }
    }
    const url = examType === "1" ? resultUrl : examUrl;

    setLoading(true);

    axios
      .get(url, { params })
      .then((response) => {
        setShowInfo(true);
        // setInfo(response.data.data.info);
        setResult(response.data.data.info);
        examType === "2" ? setExamResults(Array.isArray(response.data.data?.subjects) ? response.data.data?.subjects : []) : setExamResults([])
      })
      .catch((error) => {
        const message = error.response.data.data.message || 'Xəta baş verdi'
        notification.error({
          description: message,
          placement: "topRight",
        });
        setExamResults([])
        setResult("")
      })
      .finally(() => setLoading(false));
  };

  const titles = [
    { key: "student_name", label: "Ad" },
    { key: "student_surname", label: "Soyad" },
    { key: "speciality", label: "İxtisas" },
    { key: "exam_date", label: "İmtahan tarixi" },
    { key: "exam_place", label: "İmtahan yeri" },
    { key: "exam_address", label: "İmtahan ünvanı" },
  ];

  return (
    <>
      {login ? <div className="form-page">
        <div className="header">
          <img src={logo} alt="Logo" className="logo" />
          {/* <h1 className="exam-title">Uşaq musiqi, incəsənət məktəb və mərkəzlərinə təhsilalanların qəbulu ilə bağlı keçirilmiş imtahanın nəticələri</h1> */}
        </div>
        <div className="form">
          <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} className="form-container">
            <div className="form-group" style={{ marginBottom: 40 }}>
              <label htmlFor="exam_type">İmtahan növü</label>
              <select className="select_form" id="exam_type" {...register("exam_type")}>
                <option value="">İmtahan növünü seçin</option>
                {EXAM_TYPES.map((examType) => (
                  <option key={examType.id} value={examType.id}>
                    {examType.name}
                  </option>
                ))}
              </select>
            </div>

            <h2 className="title">Namizəd məlumatları</h2>
            <div className="form-group">
              <label htmlFor="finKod">Fin kod</label>
              <input id="finKod" {...register("fin", { required: { value: true, message: "Fin kod tələb olunur" } })} className="fin" />
              {errors?.fin && <span className="error-message">{errors.fin.message}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="seriyaNo">Seriya №</label>
              <div className="seriya-container">
                <select id="seriyaNo" {...register("seriyaNo")}>
                  {isForeignPerson ? foreignPrefixes.map((prefix) => (
                    <option key={prefix} value={prefix}>
                      {prefix}
                    </option>
                  )) : citizenPrefixes.map((prefix) => (
                    <option key={prefix} value={prefix}>
                      {prefix}
                    </option>
                  ))}
                </select>
                <input id="seriyaValue" {...register("seriyaValue", { required: { value: true, message: "Seriya nömrəsi tələb olunur" } })} />
              </div>
              {errors?.seriyaValue && <span className="error-message">{errors.seriyaValue.message}</span>}
            </div>
            <div className="form-group">
              <label className="foreign">
                <input
                  type="checkbox"
                  checked={isForeignPerson}
                  onChange={handleCheckboxChange}
                />
                Xarici vətəndaş
              </label>
            </div>

            <div className="btn">
              <button type="submit" disabled={loading || !examType}>Axtar</button>
            </div>
          </form>
        </div>
        {loading && (
          <div className="loading-spinner">
            <Spin spinning={loading} size="large" />
          </div>
        )}
        {showInfo && (
          <div className="result">
            <div className="result-container">
              <h2 className="title">Axtarış nəticəsi</h2>
              {subjects.length > 0 && subjects.map((subject, index) => (
                <div className="exam_subjects" key={index}>
                  <div>{subject?.subject_name}</div>
                  <div style={{ textAlign: 'end', paddingRight: 20 }}>{+subject?.average_score}</div>
                </div>
              ))}
              {examResults.length > 0 && (
                <div className="exam_subjects" style={{ fontWeight: 'bold' }}>
                  <div>Ümumi orta göstərici</div>
                  <div style={{ textAlign: 'end', paddingRight: 20 }}>{averageScore}</div>
                </div>
              )}
              {result && <div className="">
                <div className="result-info">
                  <p dangerouslySetInnerHTML={{ __html: result }}></p>
                </div>
              </div>}
            </div>
          </div>
        )}
      </div> :
        <Login setLogin={setLogin} />
      }
    </>
  );
}

export default Home;
